module.exports = __webpack_public_path__ + "images/qrcode-btn.328f27ba.png";